import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import Link from '@risksmart-app/components/src/link';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { toLocalDate } from 'src/utils/dateUtils';
import { obligationChangeDetailsUrl } from 'src/utils/urls';

import SimpleRatingBadge from '../simple-rating-badge';

export interface Props {
  changes: {
    id: string;
    sequentialId: number;
    effectiveDate?: string;
  }[];
}

const InformationBox: FC<{
  id: string;
  sequentialId: number;
  effectiveDate?: string;
}> = ({ id, sequentialId, effectiveDate }) => {
  const { t } = useTranslation(['common'], { keyPrefix: 'obligationChanges' });
  const { getByValue } = useRating('obligation_change');

  return (
    <div
      className={
        'p-4 bg-white border-grey150 border-solid border-2 rounded-md flex gap-2 text-xs'
      }
      key={`lr-${id}`}
    >
      <div className={'grid grid-cols-2 gap-4 w-full'}>
        <div className={'col-span-2 w-full'}>
          <SimpleRatingBadge rating={getByValue('upcoming')} />
        </div>
        <span
          className={'font-semibold text-gray-400'}
        >{`${t('columns.id')}:`}</span>

        <Link
          className={'!flex !justify-end !text-xs'}
          href={obligationChangeDetailsUrl(id)}
        >
          {`RCF-${sequentialId}`}
        </Link>

        <span className={'font-semibold text-gray-400'}>
          {`${t('columns.effective_date')}:`}
        </span>
        <span className={'flex justify-end'}>{toLocalDate(effectiveDate)}</span>
      </div>
    </div>
  );
};

export const ObligationChangeInformation: FC<Props> = ({ changes }) => {
  return (
    <div
      className={`p-5 bg-off_white rounded-md flex flex-col gap-4 justify-items-start`}
    >
      <span className={'m-0 font-semibold text-grey500'}>
        {`Obligation changes`}
      </span>
      {changes.map((change) => (
        <InformationBox
          key={change.id}
          id={change.id}
          sequentialId={change.sequentialId}
          effectiveDate={change.effectiveDate}
        />
      ))}
    </div>
  );
};

export default ObligationChangeInformation;
